<template>
    <div>
        <!-- Global In the main.js file -->
        <!-- import VueDatePicker from '@vuepic/vue-datepicker'
        import '@vuepic/vue-datepicker/dist/main.css'
        app.component('VueDatePicker', VueDatePicker) -->
        <VueDatePicker model-type="yyyy-MM-dd" :model-value="modelValue"
            @update:model-value="$emit('update:model-value', $event)" :format="formatDate" :format-locale="th"
            :enable-time-picker="false" auto-apply :placeholder="placeholder" :required="required"
            :disabled="disabled" />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { th } from 'date-fns/locale';
import moment from 'moment';
moment.locale('th')

export default defineComponent({
    name: 'DatePicker',
    props: {
        modelValue: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: 'เลือกวันที่'
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            th: th
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).add(543, 'year').format('DD MMM YYYY'); // Format for display
        }
    }
});
</script>

<style scoped>
/* Add your styles here */
</style>
